/** Brief 12, `Bitimlar`: the board, the list, the panel and the two dialogs. */
export const uzB12Deals = {
  "deals.title": "Bitimlar",
  "deals.readOnly": "Faqat ko'rish",
  "deals.filter.idle": "Harakatsiz bitimlar",
  "deals.head.open": "{count} ochiq",
  "deals.head.mine": "mening bitimlarim",
  "deals.head.branch": "{branch} filiali",
  "deals.view.label": "Ko'rinish",
  "deals.view.kanban": "Kanban",
  "deals.view.list": "Ro'yxat",
  "deals.new": "Yangi bitim",
  "deals.search.placeholder": "Mijoz, bitim № yoki yo'nalish",
  "deals.search.label": "Bitimlardan qidirish",
  "deals.filter.owner": "Mas'ul",
  "deals.filter.branch": "Filial",
  "deals.filter.all": "Hammasi",
  "deals.filter.lost": "Yo'qotilganlar",
  "deals.filter.empty": "Filtrga mos bitim yo'q",
  "deals.filter.reset": "Filtrni tozalash",
  "deals.empty.title": "Hali bitim yo'q",
  "deals.empty.body": "Bitim murojaatdan yoki qo'lda yaratiladi. Voronka bosqichlari Sozlamalarda.",
  "deals.empty.action": "Murojaatlarga",
  "deals.error.title": "Bitimlar yuklanmadi",
  "deals.board.lostColumn": "Yo'qotildi",
  "deals.board.noDeals": "Bitim yo'q",
  "deals.board.systemStage": "Tizim bosqichi",
  "deals.board.addStage": "Bosqich qo'shish",
  "deals.board.pickStage": "Bosqich",
  "deals.card.idle": "Harakatsiz {days} kun",
  "deals.card.pax": "{count} kishi",
  "deals.due.today": "Bugun",
  "deals.due.yesterday": "Kecha",
  "deals.lead.hot": "Issiq",
  "deals.lead.warm": "Iliq",
  "deals.lead.cold": "Sovuq",
  "deals.move.refused": "Bosqichni o'zgartirib bo'lmadi",
  "deals.move.failed": "«{stage}» bosqichiga o'tmadi · aloqa uzildi. Kartochka eski joyiga qaytarildi.",
  "deals.move.done": "№{id} · {stage}",
  "deals.move.lost": "№{id} yo'qotildi · sabab: {reason}",
  "deals.list.number": "Bitim",
  "deals.list.client": "Mijoz",
  "deals.list.destination": "Yo'nalish",
  "deals.list.stage": "Bosqich",
  "deals.list.sum": "Summa",
  "deals.list.rest": "Qoldiq",
  "deals.list.owner": "Mas'ul",
  "deals.list.due": "Muddat",
  "deals.list.label": "Bitimlar ro'yxati",
  "deals.list.previous": "Oldingi",
  "deals.list.next": "Keyingi",
  "deals.panel.number": "Bitim №{id}",
  "deals.panel.open": "To'liq ochish",
  "deals.panel.next": "«{stage}» bosqichiga o'tkazish",
  "deals.panel.chat": "Suhbat",
  "deals.panel.pay": "To'lov kiritish",
  "deals.panel.lose": "Yo'qotildi",
  "deals.panel.lost": "Yo'qotildi",
  "deals.panel.ai": "Kapitan AI · qisqacha",
  "deals.panel.money": "Pul",
  "deals.panel.total": "Jami",
  "deals.panel.paid": "To'langan",
  "deals.panel.rest": "Qoldiq",
  "deals.panel.tour": "Tur",
  "deals.panel.destination": "Yo'nalish",
  "deals.panel.dates": "Sanalar",
  "deals.panel.tourists": "Turistlar",
  "deals.panel.hotel": "Mehmonxona",
  "deals.panel.hotelNone": "Tanlanmagan",
  "deals.panel.owner": "Mas'ul",
  "deals.panel.source": "Manba",
  "deals.panel.lostReason": "Yo'qotish sababi",
  "deals.panel.bookings": "Bronlar",
  "deals.panel.bookingsAll": "Barchasi",
  "deals.panel.noBooking": "Bron hali yo'q",
  "deals.panel.searchTour": "Tur qidirish",
  "deals.panel.missing": "Bitim topilmadi yoki sizga ochiq emas.",
  "deals.panel.back": "Bitimlarga qaytish",
  "deals.panel.loadError": "Bitimni yuklab bo'lmadi",
  "deals.loss.title": "Nega yo'qotildi?",
  "deals.loss.subtitle": "№{id} · {name}. Sabab hisobotlarda yo'qotish grafigiga tushadi.",
  "deals.loss.state": "Yakuniy holat",
  "deals.loss.comment": "Izoh",
  "deals.loss.commentHint": "Nima bo'ldi",
  "deals.loss.confirm": "Yo'qotildi deb belgilash",
  "deals.loss.cancel": "Bekor qilish",
  "deals.new.title": "Yangi bitim",
  "deals.new.client": "Mijoz",
  "deals.new.clientHint": "Ism yoki telefon",
  "deals.new.clientRequired": "Mijozni kiriting",
  "deals.new.clientNew": "Yangi mijoz: {name}",
  "deals.new.name": "Mijoz ismi",
  "deals.new.nameRequired": "Yangi mijozning ismini kiriting",
  "deals.new.destination": "Yo'nalish",
  "deals.new.destinationHint": "Masalan, Turkiya · Antalya",
  "deals.new.dates": "Sanalar",
  "deals.new.dateFrom": "Boshlanish sanasi",
  "deals.new.dateTo": "Tugash sanasi",
  "deals.new.pax": "Kishilar",
  "deals.new.source": "Manba",
  "deals.new.cancel": "Bekor qilish",
  "deals.new.save": "Saqlash",
  "deals.new.created": "Bitim №{id} yaratildi",
  "deals.new.failed": "Bitimni saqlab bo'lmadi",
  "deals.stage.title": "Bosqich qo'shish",
  "deals.stage.name": "Bosqich nomi",
  "deals.stage.hint": "Masalan, Ofisga keldi. Agentlik bosqichlari «Bron» dan oldin turadi.",
  "deals.stage.save": "Qo'shish",
  "deals.stage.failed": "Bosqichni qo'shib bo'lmadi",
  "deals.source.telegram": "Telegram",
  "deals.source.instagram_dm": "Instagram",
  "deals.source.instagram_comment": "Instagram komment",
  "deals.source.instagram_ad": "Instagram reklama",
  "deals.source.phone": "Qo'ng'iroq",
  "deals.source.walk_in": "Ofisga kelgan",
  "deals.source.referral": "Tavsiya",
  "deals.source.website": "Sayt",
} as const;
